const translations = {
    clientNameFieldPlaceholder: 'Client Name',
    contactNameFieldPlaceholder: 'Contact Name',
    emailFieldPlaceholder: 'Email',
    phoneNumberFieldPlaceholder: 'Phone'
};

export default translations;
